<app-topbar></app-topbar>
<div *ngIf = "divReady">
<div *ngIf="companyEmpty; else elseBlock">
    <div class="container mr-top-40">
        <h1 class="mainhdng mr-bttm-30">Company & Store</h1>
    </div>
            
    <div class="container cntremptyscrn">
        <div class="row h-80 justify-content-center align-items-center">
            <div class="common noproductsdiv text-center">
                <img src="assets/images/company-n-stores-without-info.png" class="noprdctimg">
                <h3 class="noprdcrthdng">You don't have any company and store yet </h3>
                <p class="noprdcrt_subhdng">Click below to setup your first company and store</p>
                <button routerLink ="/add-company-store" class="getstrtd noinfobttn">Get Started</button>
            </div>
        </div>
    </div>
</div>
<ng-template #elseBlock>
<div class="container mr-top-56 respmrt-30">
     <h1 class="mainhdng mr-bttm-30 pyhdngresp ">Company & Store</h1>
     <h3 class="pyhdng">Company</h3>
     <div class="table-responsive table-borderless roundbor">
        <table class="table cstm_tble_cs NewTblBrdr">
        <thead>
        <tr class="active thead">
            <th style="width:16%">Company Name</th>
            <th style="width:18%">Owner Full Name</th>
            <th style="width:14%">Email</th>
            <th style="width:16%">Phone Number</th>
            <th style="width:30%">Contact Information</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td><p class="boxpara">{{company_name}}</p></td>
            <td><p class="boxpara">{{owner_name}}</p></td>
            <td><p class="boxpara">{{email_Address}}</p></td>
            <td><p class="boxpara">{{contact_number | mask: '(000) 000-0000'}}</p></td>
            <td><p class="boxpara"><span *ngIf="address_line1">{{address_line1}}, </span><span *ngIf="address_line2">{{address_line2}}, </span><span *ngIf="city">{{city}}, </span><span *ngIf="stateName">{{stateName}}, </span><span *ngIf="zip">{{zip}}, </span><span *ngFor="let country of countries"><span *ngIf="country.id == country_id">{{country.name}}</span></span></p></td>
            <td><a href="javascript:void(0)" data-toggle="modal" data-target="#updateCompany"><i class="fa fa-pencil" aria-hidden="true"></i></a></td>
        </tr>
        </tbody>
        </table>
     </div>
  <!-- {{Stores | json}} -->
  <h3 class="pyhdng mt70">Stores <a href="javascript:void(0);" class="addanothstore resaddstr" data-toggle="modal" data-target="#updateStore" (click) ="addStore()"><img src="assets/images/addanothersrore.png" />Add Another Store</a></h3>
    <div class="table-responsive roundbor">
     <table class="table cstm_tble_cs table-responsive table-borderless NewTblBrdr newexpandcollapse">
    <thead>
      <tr class="active thead">
        <th style="width:100%;padding-top: 10px !important;padding-bottom: 10px !important;padding-left: 15px !important;">Store Name</th>
		<th width="0" style="padding:0.1px !important;"></th>
        <!--<th style="width:18%">Manager Full Name</th>
        <th style="width:14%">Email</th>
        <th style="width:16%">Phone Number</th>
        <th style="width:30%">Contact Information</th>
        <th></th>-->
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let store of Stores let i = index">
        <td width="100%" class="paddingetcremove">
			<table width="100%">
				<tr>
					<td (click)="toggle(i)">
			<p class="boxpara boxparanameexpand"><img class="small_img_str" src="{{store.Storeimage}}" (error)="updateUrl($event,store.id,i)"/><span class="str_nm">{{store.store_name}}  <i class="fa fa-chevron-up" aria-hidden="true" *ngIf= "i == hideRuleContent" style="margin-left:10px;cursor:pointer;"></i>
						<i class="fa fa-chevron-down" aria-hidden="true" *ngIf="hideRuleContent != i" style="margin-left:10px;cursor:pointer;"></i></span>
						
						</p>
					</td>
					 <td align="right"><a href="javascript:void(0)" data-toggle="modal" data-target="#updateStore" (click) = "fillStoreForm(i)"><i class="fa fa-pencil" aria-hidden="true"></i></a></td>
				</tr>
				<tr *ngIf="i == hideRuleContent">
					<td width="100%" class="expanddatanewdiv" colspan="2">
					  <table width ="100%">
						  <tr>
							  <td><p class="boxpara"><b>Manager Full Name:</b> {{store.owner_name}}</p></td>
							  <td><p class="boxpara"><b>Phone Number:</b> {{store.contact_number | mask: '(000) 000-0000'}}</p></td>
						  </tr>
						    <tr>
								<td><p class="boxpara"><b>Email:</b> {{store.email_Address}}</p></td>
								<td><p class="boxpara"><b>Contact Information:</b> <span *ngIf="store.address_line1">{{store.address_line1}}, </span><span *ngIf="store.address_line2 != null">{{store.address_line2}}, </span><span *ngIf="city">{{store.city}}, </span><span *ngIf="store.stateName">{{store.stateName}}, </span><span *ngIf="zip">{{store.zip}}, </span><span *ngFor="let country of countries"><span *ngIf="country.id == store.country">{{country.name}}</span></span></p></td>
						  </tr>
						</table>
					</td>
				</tr>
			</table>
		</td>
        <!-- <td><p class="boxpara">{{store.owner_name}}</p></td>
        <td><p class="boxpara">{{store.email_Address}}</p></td>
       <td><p class="boxpara">{{store.contact_number | mask: '(000) 000-0000'}}</p></td>
        <td><p class="boxpara"><span *ngIf="store.address_line1">{{store.address_line1}}, </span><span *ngIf="store.address_line2 != null">{{store.address_line2}}, </span><span *ngIf="city">{{store.city}}, </span><span *ngIf="store.stateName">{{store.stateName}}, </span><span *ngIf="zip">{{store.zip}}, </span><span *ngFor="let country of countries"><span *ngIf="country.id == store.country">{{country.name}}</span></span></p></td>
        <td><a href="javascript:void(0)" data-toggle="modal" data-target="#updateStore" (click) = "fillStoreForm(i)"><i class="fa fa-pencil" aria-hidden="true"></i></a></td>-->
      </tr>
    </tbody>
     </table>
    </div>
  
</div>
</ng-template>
</div>
<!-- Update Company Detail Modal -->
<div class="modal centerModalNew fade in" id="updateCompany">
<div class="modal-dialog">
<div class="modal-content">    


<!-- Modal body -->
<div class="modal-body changeimagebody">
    <div class="common billingform ">
        <div class="changeimagediv text-center mr-top-60">
            
            <form [formGroup]="company_update" (ngSubmit)="company_submit($event)">
                <h6 class="sucssheading clrgry text-left">Edit Company</h6>
                <div class="row">
                    <div class="form-group col-md-6">
                        <input formControlName="company_name" id="company_name" type="text"  class="form-control" placeholder="Enter Company name">
                        <div *ngIf="companySubmitted && company_form.company_name.invalid">
                            <span class="inputValidation" *ngIf="company_form.company_name.errors.required">Company name is required.</span>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <input formControlName="owner_name" id="owner_name" type="text"  class="form-control" placeholder="Enter Owner name">
                        <div *ngIf="companySubmitted && company_form.owner_name.invalid">
                            <span class="inputValidation" *ngIf="company_form.owner_name.errors.required">Owner name is required.</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <input formControlName="contact_number" id="contact_number" type="text"  class="form-control" placeholder="Enter Contact number" maxlength="15" minlength="10" mask='(000) 000-0000'>
                        <div *ngIf="companySubmitted && company_form.contact_number.invalid">
                            <span class="inputValidation" *ngIf="company_form.contact_number.errors.required">Contact number is required.</span>
                            <span class="inputValidation" *ngIf="company_form.contact_number.errors.minlength">Contact number is not valid.</span>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <input formControlName="email" id="email" type="email"  class="form-control" placeholder="Enter Email address">
                        <div *ngIf="companySubmitted && company_form.email.invalid">
                            <span class="inputValidation" *ngIf="company_form.email.errors.required">Email address is required.</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <input type="text" class="form-control" placeholder="Address Line 1" id="address_line1" formControlName="address_line1">
                        <div *ngIf="companySubmitted && company_form.address_line1.invalid" >
                            <span class="inputValidation" *ngIf="company_form.address_line1.errors.required">Address Line 1 is required.</span>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <input type="text" class="form-control" placeholder="Address Line 2" id="address_line2" formControlName="address_line2">
                    </div>
                    
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <select class="pymntmthds form-control " id="country" autocomplete="off" (change)="changeState($event.target.value)" formControlName="country">
                            <option value="">Select Country</option>
                            <option *ngFor="let country of countries" [value]="country.id">
                            {{country.name}}</option>
                        </select>
    
                        <div *ngIf="companySubmitted && company_form.country.invalid" >
                            <span class="inputValidation" *ngIf="company_form.country.errors.required">Country is required.</span>
                        </div>
                        </div>
                    <div class="form-group col-md-6">
                        
                        <div *ngIf="stateLoading else selectState">
                            <img src="assets/images/loading.gif" class="loading_gif"/>
                        </div>   
                        <ng-template #selectState>
                        <select class="pymntmthds form-control" id="State" autocomplete="off" formControlName="State">
                            <option value="">Select State</option>
                            <option *ngFor="let c_state of states" [value]="c_state.id" >
                        {{c_state.name}}</option>
                        </select>
                        </ng-template> 

                    <div *ngIf="companySubmitted && company_form.State.invalid" >
                        <span class="inputValidation" *ngIf="company_form.State.errors.required">State is required.</span>
                    </div>
                    </div>
                    <div class="form-group col-md-6">
                       <input formControlName="city" type="text" class="form-control" id="city" placeholder="City" >
                        <div *ngIf="companySubmitted && company_form.city.invalid" >
                            <span class="inputValidation" *ngIf="company_form.city.errors.required">City is required.</span>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <input formControlName="zip" type="text" class="form-control" id="zip" placeholder="Zip Code">
                        <div *ngIf="companySubmitted && company_form.zip.invalid" >
                            <span class="inputValidation" *ngIf="company_form.zip.errors.required">Zip Code is required.</span>
                        </div>
                    </div>
                </div>
                <div class="common changenumberbttn text-left">
                    <button class="savebttn ">Update</button>
                    <button class="cancelbttn company_close_modal" data-dismiss="modal">Close</button>
                  </div>
                  <div class="common text-success sccsmsgdiv" >{{company_data_update}}</div>
            </form>

        </div>
    </div>

</div>



</div>
</div>
</div>


<!-- Update Store Detail Modal -->
<div class="modal centerModalNew fade in " id="updateStore">
<div class="modal-dialog spw650">
<div class="modal-content">    


<!-- Modal body -->
<div class="modal-body changeimagebody px-5">
    <div class="common billingform ">
        <div class="changeimagediv text-center mr-top-60 mr-top-25">
            
            <form [formGroup]="store_update" (ngSubmit)="store_submit($event)">
                <h6 class="sucssheading clrgry text-left text-dark" id="stroehead">Add Store</h6>
                <div class="row">
                <div class="formrow col-md-4 text-left">
                                <span class="upldimg">
                                    <p class="imgfrme">
                                       <span>
                                       <img [src]="Storeimage"
                       [hidden]="!Storeimage"  />
                                       </span>
                                    </p>
                                 </span>
                                 <img src="assets/images/uploadlogo.png"/>
                                  <label for="files" class="uploadlogoclass">Upload Logo</label>
					<p style="font-size: 13px;color: #29334A;font-family: 'Barlow', sans-serif;font-weight: 400;margin-top:10px;">(Square logo with atleast a size of 400 X 400px)</p>
                                  <input name = "Storeimage" (change)="selectImageStore($event)" accept="image/x-png,image/gif,image/jpeg" id="files" style="visibility:hidden;" type="file">
					
                            </div>
                            
                            <div class="formrow col-md-8">
                                <p class="brandtext text-left">Please, select the color of your  store branding,<br/> it will be for custom some emails.</p>
                            
                            <div class="formrow formrowcolorsec">
                                 <div class="text-left mbottomscolor cprimaryseccolor">
                                    <div class="primary_div">
                                        <img src="assets/images/coloricon.png"/><span class="selectcolor">Select a HEX Color</span><input class="cstm_color_picker" id="cstm_color_picker" formControlName="primary_color"
                                        id="cstm_color_new"  
                                        [cpOKButton]="true"
                                        [cpSaveClickOutside]="false"
                                        [cpOKButtonClass]= "'btn btn-primary btn-xs'"
                                        [(colorPicker)]="primary_color" autocomplete="off" readonly
                                        (colorPickerSelect)="handleChangeComplete($event)"/>
                                    </div>
                                    <div *ngIf="storeSubmitted && store_form.primary_color.invalid">
                                        <span class="inputValidation" *ngIf="store_form.primary_color.errors.required">HEX Color is required.</span>
                                </div>
                                
                        </div>
                            </div>
                            </div>
                        </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <input formControlName="store_name" id="store_name" type="text"  class="form-control" placeholder="Store name">
                        <div *ngIf="storeSubmitted && store_form.store_name.invalid">
                            <span class="inputValidation" *ngIf="store_form.store_name.errors.required">Store name is required.</span>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <input formControlName="owner_name"  id="owner_name" type="text"  class="form-control" placeholder="Owner name">
                        <div *ngIf="storeSubmitted && store_form.owner_name.invalid">
                            <span class="inputValidation" *ngIf="store_form.owner_name.errors.required">Owner name is required.</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <input formControlName="contact_number" id="contact_number" type="text"  class="form-control" placeholder="Contact number" maxlength="15" minlength="10" mask='(000) 000-0000'>
                        <div *ngIf="storeSubmitted && store_form.contact_number.invalid">
                            <span class="inputValidation" *ngIf="store_form.contact_number.errors.required">Contact number is required.</span>
                            <span class="inputValidation" *ngIf="store_form.contact_number.errors.minlength">Contact number is not valid.</span>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <input formControlName="email_Address"  id="email_Address" type="text"  class="form-control" placeholder="Email Address">
                        <div *ngIf="storeSubmitted && store_form.email_Address.invalid">
                            <span class="inputValidation" *ngIf="store_form.email_Address.errors.required">Email Address is required.</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-12">
                        <input formControlName="address_line1" id="address_line1" type="text"  class="form-control" placeholder="Address Line 1">
                        <div *ngIf="storeSubmitted && store_form.address_line1.invalid">
                            <span class="inputValidation" *ngIf="store_form.address_line1.errors.required">Address Line 1 is required.</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-12">
                        <input formControlName="address_line2" id="address_line2" type="text"  class="form-control" placeholder="Address Line 2">
                    </div>
                </div>
                 <div class="row">
                    <div class="form-group col-md-6">
                        <select formControlName="country" (change)="changeStateStore($event.target.value)" name="storecountry" class="form-control" >
                            <option value="">Select Country</option>
                                <option *ngFor="let country of countries" [value]="country.id">
                                {{country.name}}</option>
                            </select>
                            <div *ngIf="storeSubmitted && store_form.country.invalid">
                                <span class="inputValidation" *ngIf="store_form.country.errors.required">Country is required.</span>
                            </div>
                        
                    </div>
                    <div class="form-group col-md-6">
                        <div *ngIf="stateLoadingStore else selectStateStore">
                            <img src="assets/images/loading.gif" class="loading_gif"/>
                        </div>   
                        <ng-template #selectStateStore>
                            <select formControlName="State" class="pymntmthds form-control" id="State" autocomplete="off"
                                name="storestate" ngModel="State">
                                <option value="">Select State</option>
                                <option *ngFor="let state_store of States" [value]="state_store.id">
                                {{state_store.name}}
                                </option>
                            </select>
                        </ng-template>
                        <div *ngIf="storeSubmitted && store_form.State.invalid">
                            <span class="inputValidation" *ngIf="store_form.State.errors.required">State is required.</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-4">
                        <input formControlName="city"  id="city" type="text"  class="form-control" placeholder="City">
                        <div *ngIf="storeSubmitted && store_form.city.invalid">
                            <span class="inputValidation" *ngIf="store_form.city.errors.required">City is required.</span>
                        </div>
                    </div>
                    <div class="form-group col-md-4">
                        <input formControlName="zip" id="zip" type="text"  class="form-control" placeholder="Zip Code">
                        <div *ngIf="storeSubmitted && store_form.zip.invalid">
                            <span class="inputValidation" *ngIf="store_form.zip.errors.required">Zip Code is required.</span>
                        </div>
                    </div>
                    <div class="form-group col-md-4">
                        <select formControlName="timezone" ngModel="timezone" name="timezone" class="form-control">
                            <option value="">Select Timezone</option>
                            <option *ngFor="let timezone of timezones" [value]="timezone.name">
                                {{timezone.gmt}}</option>
                        </select>
                        <div *ngIf="storeSubmitted && store_form.timezone.invalid">
                            <span class="inputValidation" *ngIf="store_form.timezone.errors.required">Timezone is required.</span>
                        </div>
                    </div>
                </div>

                <div class="common changenumberbttn text-left">
                    <button class="savebttn">Update</button>
                    <button class="cancelbttn close_store_modal" data-dismiss="modal">Close</button>
                  </div>
                  <div class="common text-success sccsmsgdiv" >{{store_added}}</div>
            </form>

        </div>
    </div>

</div>



</div>
</div>
</div>
					